module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><g stroke-width=\"2\" stroke=\"#6c6c6c\" fill=\"none\"><path d=\"M11.29 11.71l-4-4\"></path><circle cx=\"5\" cy=\"5\" r=\"4\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/Vector_search_icon.svg
// module id = 281
// module chunks = 0 1